import type { GetStaticPaths, GetStaticProps } from "next"
import {
  getNewsletterArchive,
  getNewsletterPageParams,
  type TeaserArchiveProps,
} from "@/components/resources/data/archives"
import { SiteLayout } from "@/components/resources/layouts/site"
import { CategoryArchive } from "@/components/resources/templates/CategoryArchive"
import { parsePageParam } from "@/components/resources/utils/pagination"

const Archive = (props: TeaserArchiveProps) => <CategoryArchive {...props} />

Archive.getLayout = SiteLayout

export default Archive

// Blocking fallback: new issues can add a page between deploys
export const getStaticPaths: GetStaticPaths = async () => ({
  paths: (await getNewsletterPageParams()).map((n) => ({ params: { n } })),
  fallback: "blocking",
})

export const getStaticProps: GetStaticProps<
  TeaserArchiveProps,
  { n: string }
> = async ({ params }) => {
  const page = parsePageParam(params?.n)
  const props = page ? await getNewsletterArchive(page) : null
  // The 404 revalidates too: a Beehiiv outage only shortens the list for a while
  return props
    ? { props, revalidate: 180 }
    : { notFound: true, revalidate: 180 }
}
